/**
 * Data visualization: Wine colors
 */
export var wine10 = '#fbb9cf';
export var wine10opacity20solidDark = '#504852';
export var wine20 = '#f38eb0';
export var wine30 = '#e86e97';
export var wine30opacity20solidDark = '#4c3947';
export var wine40 = '#d85782';
export var wine40opacity20solid = '#f7dde6';
export var wine50 = '#c2466f';
export var wine60 = '#a6375c';
export var wine60opacity20solid = '#edd7de';
export var wine70 = '#842947';
export var wine80 = '#611d34';
